"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Sort the given object by its keys
 *
 * @param   {ObjectInterface} object
 * @returns {ObjectInterface}
 */
function sort(object) {
    return Object.keys(object).sort().reduce(function (accumulator, currentValue) {
        accumulator[currentValue] = object[currentValue];
        return accumulator;
    }, {});
}
exports.default = sort;
;
//# sourceMappingURL=sort.js.map